import React, { useState } from 'react';
import TopNavigation from './Components/Navigation/TopNavigation.jsx';
import Sidebar from './Components/Navigation/Sidebar.jsx';

export default function Layout({ children, currentPageName }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // LawDetail page has its own enhanced layout with navigation
  if (currentPageName === 'LawDetail') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-cyan-50">
        <TopNavigation onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
        <div className="pt-14 sm:pt-16 flex">
          <Sidebar isMobileOpen={isMobileMenuOpen} setIsMobileOpen={setIsMobileMenuOpen} />
          <main className="flex-1 min-h-[calc(100vh-3.5rem)] sm:min-h-[calc(100vh-4rem)] lg:ml-96 w-full overflow-x-hidden">
            {children}
          </main>
        </div>
      </div>
    );
  }

  // Home page with simplified layout
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-cyan-50 overflow-x-hidden">
      <TopNavigation onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
      <main className="pt-14 sm:pt-16 overflow-x-hidden">
        {children}
      </main>
    </div>
  );
}